export default "__VITE_ASSET__32d4a4cf__"